export default {
    prepareDataDoseQuantification(busEvent, formQuantification) {
        let dataSaveDoseQuantification = [];

        formQuantification.map(vacinaDoses => {
            if(vacinaDoses.numberOfDosesWithoutPromotion.quantity) {
                dataSaveDoseQuantification.push(
                    {
                        id_vacina: vacinaDoses.id_vacina,
                        id_incentivo: vacinaDoses.numberOfDosesWithoutPromotion.incentive,
                        quantidade: vacinaDoses.numberOfDosesWithoutPromotion.quantity,
                        usePriceRange: vacinaDoses.usePriceRange
                    }
                );
            }
            if(vacinaDoses.numberOfDosesWithPromotion.quantity && !vacinaDoses.usePriceRange) {
                dataSaveDoseQuantification.push(
                    {
                        id_vacina: vacinaDoses.id_vacina, 
                        id_incentivo: vacinaDoses.numberOfDosesWithPromotion.incentive,
                        quantidade: vacinaDoses.numberOfDosesWithPromotion.quantity,
                        usePriceRange: vacinaDoses.usePriceRange
                    }
                );
            }
        });

        busEvent.$emit('doseQuantificationDataCampaign', dataSaveDoseQuantification);
    }
}